(function () {
  'use strict';

  /* @ngdoc object
   * @name account.earnings
   * @description
   *
   */
  angular
    .module('account.earnings', [
      'ui.router'
    ]);
}());
